<lib-card>
  <ng-container title> Piano d'azione strategico </ng-container>

  <ng-container actions>
    <div class="hidden gap-2 lg:flex">
      <p-button
        icon="pi pi-chevron-left"
        [rounded]="true"
        [text]="true"
        severity="secondary"
        styleClass="h-2rem w-2rem"
        (onClick)="scroll('left')"
        [disabled]="containerIsAtStart()"
      ></p-button>
      <p-button
        icon="pi pi-chevron-right"
        [rounded]="true"
        [text]="true"
        severity="secondary"
        styleClass="h-2rem w-2rem"
        (onClick)="scroll('right')"
        [disabled]="containerIsAtEnd()"
      ></p-button>
    </div>
  </ng-container>

  <ng-container content>
    <div
      #scrollContainer
      class="custom-scrollbar grid w-full grid-cols-1 flex-row gap-3 scroll-smooth px-1 pb-2 pt-4 sm:grid-cols-2 md:grid-cols-3 lg:flex lg:overflow-x-auto"
    >
      @for (action of actions(); track $index) {
        <div
          class="flex min-w-[calc(33%-12px)] flex-col rounded-lg border bg-white p-3 shadow-sm transition-all"
          [class.border-red-400]="action.type === 'high'"
          [class.border-yellow-400]="action.type === 'medium'"
          [class.border-green-400]="action.type === 'low'"
        >
          <div class="flex flex-col gap-2">
            <div class="flex flex-auto items-center justify-between gap-1">
              <div
                class="flex items-center gap-1 text-xs font-bold uppercase"
                [class.text-red-500]="action.type === 'high'"
                [class.text-yellow-500]="action.type === 'medium'"
                [class.text-green-500]="action.type === 'low'"
              >
                @if (action.type === 'high') {
                  <i class="pi pi-flag-fill text-[10px]"></i>
                } @else if (action.type === 'medium') {
                  <i class="pi pi-clock text-[10px]"></i>
                } @else {
                  <i class="pi pi-check-circle text-[10px]"></i>
                }
                <span class="text-base">{{ action.priority }}</span>
              </div>
              <span
                class="whitespace-nowrap rounded-full bg-slate-100 px-2 py-0.5 text-sm font-bold uppercase text-slate-500"
              >
                {{ action.timeframe }}
              </span>
            </div>

            <p class="text-base font-medium leading-normal text-slate-700">
              {{ action.description }}
            </p>

            <div
              class="mt-2 rounded-lg border border-slate-100 bg-slate-50 p-2"
            >
              <span
                class="mb-1 block text-sm font-bold uppercase tracking-tighter text-slate-400"
              >
                Attività consigliate
              </span>
              <ul
                class="block list-inside list-disc text-base font-semibold text-slate-600"
              >
                @for (act of action.actions; track $index) {
                  <li>{{ act }}</li>
                }
              </ul>
            </div>
          </div>
        </div>
      }
    </div>
  </ng-container>
</lib-card>
